import React, { HtmlHTMLAttributes } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  button: {
    '&, &:focus': {
      padding: '0',
      outline: 'none',
      border: 'none',
      borderWidth: '0',
      background: 'rgba(0,0,0,0)'
    },

    '& img': {
      userDrag: 'none',
      '&.gbtn-normal': { display: 'block' },
      '&.gbtn-focus': { display: 'none' },
      '&.gbtn-pressed': { display: 'none' },
      '&.gbtn-disabled': { display: 'none' }
    },
    '&:focus img': {
      '&.gbtn-normal': { display: 'none' },
      '&.gbtn-focus': { display: 'block' },
      '&.gbtn-pressed': { display: 'none' },
      '&.gbtn-disabled': { display: 'none' }
    },
    '&:active img, &:focus:active img': {
      '&.gbtn-normal': { display: 'none' },
      '&.gbtn-focus': { display: 'none' },
      '&.gbtn-pressed': { display: 'block' },
      '&.gbtn-disabled': { display: 'none' }
    },
    '&:disabled img': {
      '&.gbtn-normal': { display: 'none' },
      '&.gbtn-focus': { display: 'none' },
      '&.gbtn-pressed': { display: 'none' },
      '&.gbtn-disabled': { display: 'block' }
    }
  }
}));

interface GoogleSignInButtonProps extends HtmlHTMLAttributes<HTMLButtonElement> {
  theme?: 'light' | 'dark'
}

export const GoogleSignInButton = (props: GoogleSignInButtonProps) => {
  const {
    theme = 'light',
    children,
    ...btnProps
  } = props;
  const classes = useStyles();
  const className = [props.className, classes.button].filter(a => a).join(' ');

  return (
    <button {...btnProps} className={className}>
      <img className="gbtn-normal" src={`/assets/google-sign-in/btn_google_signin_${theme}_normal_web.png`} alt="Google Sign in" />
      <img className="gbtn-focus" src={`/assets/google-sign-in/btn_google_signin_${theme}_focus_web.png`} alt="Google Sign in" />
      <img className="gbtn-pressed" src={`/assets/google-sign-in/btn_google_signin_${theme}_pressed_web.png`} alt="Google Sign in" />
      <img className="gbtn-disabled" src={`/assets/google-sign-in/btn_google_signin_${theme}_disabled_web.png`} alt="Google Sign in" />
    </button>
  );
};

export default GoogleSignInButton;
